/**
 * riskreducer.js
 * Created by calhosh on 11/6/2019.
 */

import * as types from '../../actions/actiontypes';
import initialstate from '../initialstate';
import _ from 'lodash';
import {entities, HttpStatusCodes} from '../../util/uiconstants';

const deleteRiskFromStore = (riskId, state, isManageEstimate = false) => {
	let clonedState = _.cloneDeep(state);
	if (isManageEstimate) {
		clonedState.manageEstimate.data = clonedState.manageEstimate.data?.filter((entity) => entity.id !== Number(riskId));
	}
	clonedState.data = clonedState.data?.filter((entity) => entity.id !== Number(riskId));
	return clonedState;
};

export function risksReducer(state = initialstate.risks, action) {
	switch (action.type) {
		case types.GET_RISKS:
			if (action?.isEstimateLeadsheet) {
				let newState = _.cloneDeep(state);
				newState.estimates = action.response;
				return newState;
			}
			if (action?.isManageEstimates) {
				let newState = _.cloneDeep(state);
				newState.manageEstimate = action.response;
				return newState;
			}
			return action.response || state;
		// return {
		// 	...state,
		// 	...action.response
		// };

		case types.GET_RISK_BY_ID:
			// If the risk is not found, remove it from the list (concurrency scenario)
			if (action?.error?.response.status === HttpStatusCodes.NotFound)
				return deleteRiskFromStore(action.riskId, state, action?.isManageEstimates);
			return state;
		case types.UPDATE_RISK:
			if (action?.error?.response.status === HttpStatusCodes.NotFound) {
				return deleteRiskFromStore(action.risk.id, state, action?.isManageEstimates);
			}

			if (action?.error) {
				return state;
			}

			if (action?.isManageEstimates) {
				let newState = _.cloneDeep(state);
				if (newState?.manageEstimate?.data) {
					let updatedEstimates = newState.manageEstimate.data.filter((e) => e.id !== action.response.id);
					newState.manageEstimate.data = [...updatedEstimates, action.response];
				}
				return newState;
			}
			if (action.responseObj.status === HttpStatusCodes.Ok) {
				let newState = _.cloneDeep(state);
				const editIndex = newState?.data?.findIndex((x) => x.id === action.response.id);
				if (editIndex > -1) {
					newState.data[editIndex] = action.response;
				}

				return newState;
			}

			return state;

		case types.CREATE_RISK:
			if (action.responseObj.status === HttpStatusCodes.Ok) {
				let newState;

				if (Object.keys(state).length === 0) {
					newState = {
						data: [action.response],
						manageEstimate: {data: [action.response]}
					};
				} else {
					newState = _.cloneDeep(state);
					if (action.isManageEstimates) {
						newState = {
							...newState,
							manageEstimate: {data: [...(state.manageEstimate?.data || []), action.response]}
						};
					}
					newState.data = [..._.cloneDeep(state.data), action.response];
				}
				return newState;
			}
			return state;
		case types.DELETE_RISK: {
			if (
				action.responseObj.status === HttpStatusCodes.Ok ||
				action.error.response.status === HttpStatusCodes.NotFound
			) {
				return deleteRiskFromStore(action.riskId, state, action?.isManageEstimates);
			}
			return state;
		}

		case types.RELATE_SCOT_TO_RISK:
			if (action.response && action.responseObj.status === HttpStatusCodes.Ok) {
				return {...state, riskScot: action.response};
			}
			return state;

		case types.UNRELATE_SCOT_TO_RISK:
			if (action.responseObj.status === HttpStatusCodes.NoContent) {
				return state;
			}
			break;

		case types.RELATE_ESTIMATE_TO_RISK: {
			if (action.response && action.responseObj.status === HttpStatusCodes.Created) {
				return state;
			}
			return state;
		}

		case types.UNRELATE_ESTIMATE_TO_RISK: {
			if (action.responseObj.status === HttpStatusCodes.NoContent) {
				return state;
			}
			return state;
		}
		default:
			return state;
	}
}

export function wcgwRelatedRisksReducer(state = initialstate.wcgwRelatedRisks, action) {
	switch (action.type) {
		case types.GET_RISKS_FOR_WCGWID:
			return action.response.value || state;

		default:
			return state;
	}
}

export function relatedRisksReducer(state = initialstate.wcgwRelatedRisks, action) {
	switch (action.type) {
		case types.GET_RELATED_RISKS_FOR_WCGWID:
			return action.response || state;
		default:
			return state;
	}
}

export function newRiskReducer(state = initialstate.risks, action) {
	switch (action.type) {
		case types.CREATE_RISK:
			if (action.responseObj.status === HttpStatusCodes.Ok) {
				return action.response;
			}
			return state;
		case types.CLEAR_NEW_RISK:
			return {};
		default:
			return state;
	}
}

export function riskReducer(state = initialstate.risk, action) {
	switch (action.type) {
		case types.CREATE_RISK:
			return action.response || state;
		case types.GET_RISK_BY_ID:
			// If the risk is not found, remove it from the list (concurrency scenario)
			if (action?.error?.response?.status === HttpStatusCodes.NotFound)
				return deleteRiskFromStore(action.riskId, state);
			if (action?.isManageEstimates) {
				let newState = _.cloneDeep(state);
				newState.createEditEstimate = action.response;
				return newState;
			}
			return action.response || state;
		case types.GET_TOP_ENTITY_METADATA:
			// If the risk is not found, remove it from the list (concurrency scenario)
			if (action?.error?.response?.status === HttpStatusCodes.NotFound)
				return deleteRiskFromStore(action.riskId, state);
			if (action.response && action.entity && action.entity === entities.Estimate) {
				return {
					...action.response, isDisplayEstimateTypeMismatchClientSideValidationMessage: true

				};
			}
			return state;
		case types.CLEAR_RISK:
			if (action?.isManageEstimates) {
				let newState = _.cloneDeep(state);
				newState.createEditEstimate = {};
				return newState;
			}
			return {};
		case types.DISPLAY_ESTIMATETYPE_MISMATCH_CLIENT_VALIDATION_MESSAGE:
			{
				let risk = _.cloneDeep(state);
				risk.isDisplayEstimateTypeMismatchClientSideValidationMessage = action.isDisplayEstimateTypeMismatchClientSideValidationMessage;
				return risk;
			}
		case types.UPDATE_STORE_RELATE_SCOT_TO_RISK: {
			let risk = _.cloneDeep(state);
			if (risk.scots === null) {
				risk.scots = [];
			}
			risk.scots.push(action.payload.scotData);
			risk.scots.sort((a, b) => a.scotName.localeCompare(b.scotName));

			return risk;
		}
		case types.UPDATE_RISK:
			if (action.responseObj.status === HttpStatusCodes.Ok) {
				let updatedRisk = _.cloneDeep(state);
				updatedRisk.riskTypeId = action.response.riskTypeId;				
				return updatedRisk;
			}
			return state;

		case types.UPDATE_STORE_UNRELATE_SCOT_TO_RISK: {
			let risk = _.cloneDeep(state);
			let riskIndex = risk.scots.findIndex(
				(scot) => scot.riskID === action.payload.riskID && scot.scotID === action.payload.scotID
			);
			if (riskIndex !== -1) {
				risk.scots.splice(riskIndex, 1);
			}
			return risk;
		}
		case types.RELATE_ESTIMATE_TO_RISK: {
			if (action.response && action.responseObj.status === HttpStatusCodes.Created) {
				let updatedRisk = _.cloneDeep(state);
				updatedRisk.riskTypeId = action.response.riskTypeId;
				return updatedRisk;
			}
			return state;
		}

		case types.UNRELATE_ESTIMATE_TO_RISK: {
			if (action.responseObj.status === HttpStatusCodes.NoContent) {
				return state;
			}
			return state;
		}

		case types.UPDATE_STORE_UNRELATE_ACCOUNT_TO_RISK: {
			let risk = _.cloneDeep(state);
			let riskIndex = risk.accounts.findIndex((account) => account.id === action.payload.accountID);
			if (riskIndex !== -1) {
				risk.accounts.splice(riskIndex, 1);
			}
			return risk;
		}
		default:
			return state;
	}
}

export function relateRiskReducer(state = initialstate.relateRisks, action) {
	switch (action.type) {
		case types.GET_RISKS_TO_RELATE:
			return action.response || state;
		default:
			return state;
	}
}

/*
 Group Risks by Risk Types
 */
export function groupRisksByRiskTypes(risks) {
	let risksGroupedByRiskTypes = {};
	if (risks && risks.data && risks.data.length > 0) {
		risksGroupedByRiskTypes = _.chain(risks.data)
			// Group the elements of Array based on `risk type id` property
			.groupBy('riskTypeId')
			// `key` is group's name (risk type id), `value` is the array of objects (risks)
			.map((value, key) => ({riskTypeId: key, risks: value}))
			.value();
	}
	return risksGroupedByRiskTypes;
}

export function formatRisks(risks) {
	let formattedRisks = [];
	if (risks && risks && risks.length > 0) {
		formattedRisks =
			risks &&
			risks.map((risk) => {
				return {
					...risk,
					riskAbbreviation: risk.riskAbbreviation && risk.riskAbbreviation.slice(0, 1)
				};
			});
	}

	return formattedRisks;
}
